import { Grid, Typography } from "@mui/material";
import type { FC } from "react";
import EntityCard from "../../components/entityCard/EntityCard";

interface Reward {
  readonly id: string;
  readonly name: string;
  readonly description: string;
  readonly cost: number;
}

interface Props {
  readonly value: Reward;
  readonly onClick: () => void;
  readonly onContextMenu: () => void;
}

const RewardCard: FC<Props> = ({ value, onClick, onContextMenu }) => {
  return (
    <EntityCard role="ADMIN" alignChildren="center" onClick={onClick} onContextMenu={onContextMenu}>
      <Grid size={5}>
        <Typography variant="subtitle1">{value.name}</Typography>
      </Grid>
      <Grid size={5}>
        <Typography variant="subtitle1">{value.cost} pkt</Typography>
      </Grid>
    </EntityCard>
  );
};

export default RewardCard;
